import { Plus } from "lucide-react";
import React from "react";
import { ButtonFluxi } from "./Buttons/ButtonFluxi/ButtonFluxi";

type ActionClickType = (() => void) | ((value: boolean) => void);

interface ActionsButtonsProps {
  actionClick: ActionClickType;
  mainButtonLabel: string;
  mainButtonColor: string;
}

export const ActionsButtons: React.FC<ActionsButtonsProps> = ({
  actionClick,
  mainButtonLabel,
  mainButtonColor,
}) => {

  return (
    <div>
      <ButtonFluxi
        text={mainButtonLabel}
        onClick={() => actionClick(true)}
        fullWidth={false}
      >
        <Plus size={20} />
      </ButtonFluxi>
    </div>
  );
};
